<hfc-standalone-modal-container>
  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <img
      [src]="tenantConfigService.desktopLogoUrl"
      [alt]="tenantConfigService.config.productName + ' logo'"
      role="img"
      [attr.aria-label]="tenantConfigService.config.productName + ' logo'"
      loading="lazy"
    />
    <h1 class="title">Log in to your account</h1>
    <span class="subtitle">Welcome! Please enter your details.</span>

    <section class="form-section">
      <label for="login-username">Email</label>
      <hfc-text-input type="email" placeholder="Email" autocomplete="username"
                      inputId="login-username" formControlName="username"></hfc-text-input>

      <label for="login-password">Password</label>
      <div class="password">
        <hfc-text-input type="password" placeholder="Password" autocomplete="current-password"
                        inputId="login-password" formControlName="password"></hfc-text-input>
      </div>
      <div class="login-options">
        <span class="forgot-link" role="link" tabindex="0"
              (click)="onForgotClicked()"
              (keydown.enter)="onForgotClicked()"
              (keydown.space)="onForgotClicked(); $event.preventDefault()">Forgot password</span>
      </div>

    </section>
    <div *ngIf="message" class="error mb-2">
      {{ message }}
    </div>
    <div *ngIf="isRegisteredUser" class="error mb-2">
      This interface is for applicants only.<br/>
      Trying to get to {{ tenantConfigService.config.productName }} for Advisors? <a [href]="adminWebUrl">Click Here</a>
    </div>

    <hfc-button type="primary" [submit]="true" [isLoading]="isSubmitting" size="large">Login</hfc-button>
  </form>
</hfc-standalone-modal-container>
